import { useQuery } from '@tanstack/react-query'
import {
	type GetQueueListingDetailsParams,
	httpGetQueueListingDetails
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const QUEUE_LISTING_DETAILS_QUERY_KEY = 'queue-listing-details'

export const useGetQueueListingDetails = (
	params: GetQueueListingDetailsParams = {}
) =>
	useQuery({
		queryKey: [QUEUE_LISTING_DETAILS_QUERY_KEY, params],
		queryFn: () => httpGetQueueListingDetails(params)
	})
